import React from "react";
import "../styles/hamburger.css"; // Import CSS for the hamburger menu
import { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthContext from "./authContext";


const HamburgerMenu = ({ isOpen }) => {
  //const [LoggedIn, setLoggedIn ] = useState(false); // Access user and isLoggedIn from context
  const { isLoggedIn, logout } = useContext(AuthContext);

const navigate = useNavigate();
const handleClickOrders = () => {
  navigate("/orders"); // Navigates to the Order page
};
const handleClickLogout = () => {
  logout(); // Call the logout function from context
  navigate("/login"); // Redirect user to login page after logout
};
  return (

    <div className={`hamburger ${isOpen ? "open" : ""}`}>
      {/* Add the arrow created with a div */}
      <div className={`arrow ${isOpen ? "up" : "down"}`}></div>
      <span className="text-sm bb-1 border-bbb w-100 hover-color-change p-025 cursor-pointer"
      onClick={() => navigate("/profile")}>
        <i className="pi pi-user"></i>
        <span> &nbsp;&nbsp;My Account</span>
      </span>
      <span
        className="text-sm bb-1 border-bbb w-100 hover-color-change p-025 cursor-pointer"
        onClick={handleClickOrders}>
        <i className="pi pi-shopping-cart"></i>&nbsp;&nbsp;My Orders
      </span>
      <span className="text-sm bb-1 border-bbb w-100 hover-color-change p-025 cursor-pointer">
        <i className="pi pi-heart"></i>&nbsp;&nbsp;My Wishlist
      </span>
      <span className="text-sm bb-1 border-bbb w-100 hover-color-change p-025 cursor-pointer">
        <i className="pi pi-cog"></i>&nbsp;&nbsp;Settings
      </span>
      <span
              className="text-sm bb-1 border-bbb w-100 hover-color-change cursor-pointer"
              onClick={() => {
                if (isLoggedIn) {
                  handleClickLogout(); // If user is logged in, call handleLogout
                } else {
                  navigate("/login"); // If user is not logged in, navigate to /login
                }
              }}
            >
              <i className="pi pi-sign-in"></i>&nbsp;&nbsp;
              {isLoggedIn ? "Logout" : "Login or Register"}
            </span>
    </div>
  );
};

export default HamburgerMenu;
